// TODO: see if this can be phased out there are other place where we handle this more uniformly
import { useEffect } from 'react';
import { windowDimensions } from 'helpers/sharedJsHelpers';

const { useWindowDimensions, breakpoints } = windowDimensions;

export default function useScreenSize () {
  const { width } = useWindowDimensions();
  let isMobile = width <= breakpoints.sm;
  let isTablet = width > breakpoints.sm && width <= 820;
  useEffect(() => {
    isMobile = width <= breakpoints.sm;
    isTablet = width > breakpoints.sm && width <= 820;
  }, [width]);
  return {
    isMobile,
    isTablet,
    isWeb: (!isMobile && !isTablet)
  };
}
